<template>
  <div>
    <Row>
      <Col span="7">
        <div class="search-con">
          <Button @click="showEditBrandModal()" v-if="this.$getMenuAuthority('sys:car:save')" class="search-btn" type="success"><Icon type="search"/>添加</Button>
          <Button @click="showEditBrandModal('update')" v-if="this.$getMenuAuthority('sys:car:update')" class="search-btn" type="primary"><Icon type="search"/>修改</Button>
        </div>
        <Table border :columns="columns1" highlight-row @on-current-change="selectChangeBrand" :data="showBrandData.list"></Table> 
        <div class="page-con">
          <Page show-total :total="showBrandData.total" :page-size="10" @on-change="chageBrandpage" :current="showBrandData.pageNum" show-elevator class="pull-right" />
        </div>
        <Modal v-model="editBrandShow" @on-ok="saveBrandInfo()" scrollable title="编辑">
          <Form ref="brandParam" :model="brandParam" :rules="brandRuleValidate" :label-width="80" class="edit-win">
            <FormItem label="名称" prop="name">
              <Input v-model="brandParam.name" placeholder="请输入名称" style="width: 380px"></Input>
            </FormItem>
          </Form>
        </Modal>
      </Col>
      <Col span="1">&nbsp;</Col>
      <Col span="16">
        <div class="search-con">
          <Button @click="showEditCarType()" v-if="this.$getMenuAuthority('sys:car:save')" class="search-btn" type="success"><Icon type="search"/>新增</Button>
        </div>
        <Table border :columns="columns2" :data="showData.list"></Table> 
        <div class="page-con">
          <Page show-total :total="showData.total" :page-size="10" @on-change="chagepage" :current="showData.pageNum" show-elevator class="pull-right" />
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
import { fail } from 'assert';
import { constants } from 'fs';
export default {
  data () {
    return {
      editBrandShow: false,  //编辑品牌
      param: {              //查询条件
        username: '',
      },
      brandParam: {
        id:'',
        fid: 0,
        name: '',
        type: 1,
      },
      brandRuleValidate: {
        name: [
          { required: true, message: '模板名不能为空', trigger: 'blur' }
        ],
      },
      showBrandData: {     //品牌列表
        pageNum: 1
      },
      showData: {           //车系列表
        pageNum: 1,
        list:[]
      },
      columns1: [           //表头
        {title: '品牌名称',key: 'name'},
        {title: '操作',key: 'action',width: 150,align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {type: 'error',size: 'small'},
                style: {marginRight: '5px',display: this.$getMenuAuthority('sys:car:delete') ? 'inline-block' : 'none'},
                on: {
                  click: () => {
                    this.deleteInfo(params.row)
                  }
                }
              }, '删除')
            ])
          }
        }
      ],
      columns2: [           //表头
        {title: '车系名称',key: 'name'},
        {title: '操作',key: 'action',width: 150,align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {type: 'error',size: 'small'},
                style: {marginRight: '5px',display: this.$getMenuAuthority('sys:car:deletes') ? 'inline-block' : 'none'},
                on: {
                  click: () => {
                    this.deleteInfo(params.row)
                  }
                }
              }, '删除')
            ])
          }
        }
      ]
    }
  },
  activated() {
    this.getBrandList()
  },
  mounted () {
    this.getBrandList()
  },
  methods: {
    chagepage (current) {
      this.showData.pageNum = current
      this.getList()
    },
    chageBrandpage(current) {
      this.showBrandData.pageNum = current
      this.getBrandList()
    },
    showEditBrandModal (type) {
      if(type == 'update') {
        this.brandParam.id = this.brandParam.fid 
      } else {
        this.brandParam.id = ''
        this.brandParam.name = ''
      }
      this.brandParam.fid = 0
      this.brandParam.type = 1
      this.editBrandShow = true
    },
    showEditCarType() {
      this.brandParam.id == ''
      this.brandParam.name = ''
      this.brandParam.type = 2
      this.editBrandShow = true
    },
    deleteInfo(row) {
      this.$Modal.confirm({
        title: '删除',
        content: '<p>您确定要删除吗</p>',
        onOk: () => {
          this.$Loading.start()
          this.$axios.get('/car/del/'+row.id)
          .then(function (response) {
            if (response.data.success) {
              if(row.fid == 0) {
                this.getBrandList()
              } else {
                this.getList()
              }
              this.$Loading.finish()
            } else {
              this.$Message.error(response.data.errMsg)
              this.$Loading.error()
            }
          }.bind(this))
        },
        onCancel: () => {
          this.$Message.warning('已取消删除')
        }
      })
    },
    saveBrandInfo() {
      this.$refs.brandParam.validate((valid) => {
        if (valid) {
          let url = ''
          this.brandParam.id == ''? url = '/car/save' : url = '/car/update'
          this.$Loading.start()
          this.$axios.post(url,this.brandParam)
          .then(function (response) {
            if (response.data.success) {
              if(this.brandParam.fid == 0) {
                this.getBrandList()
              } else {
                this.getList()
              }
              this.$Loading.finish()
            } else {
              this.$Message.error(response.data.errMsg)
              this.$Loading.error()
            }
          }.bind(this))
        }
      })
    },
    getBrandList() {
      this.$Loading.start()
      this.$axios.get('/car/list/0/'+this.showBrandData.pageNum)
      .then(function (response) {
        if (response.data.success) {
          this.showBrandData = response.data.data
          if(this.showBrandData.list.length>0) {
            this.brandParam.fid = this.showBrandData.list[0].id
            this.getList()
          }
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
    },
    deleteBrandInfo (id) {
      this.$Modal.confirm({
        title: '删除',
        content: '<p>您确定要删除吗</p>',
        onOk: () => {
            this.$Loading.start()
            let tempfrom = [id]
            this.$axios.post('/sys/user/delete', tempfrom)
            .then(function (response) {
                if (response.data.success) {
                  this.getBrandList()
                  this.$Message.success(response.data.errMsg)
                  this.$Loading.finish()
                } else {
                  this.$Message.error(response.data.errMsg)
                  this.$Loading.error()
                }
            }.bind(this))
        },
        onCancel: () => {
          this.$Message.warning('已取消删除')
        }
      })
    },
    selectChangeBrand(currentRow, oldCurrentRow) {
      this.brandParam.fid = currentRow.id
      this.brandParam.name = currentRow.name
      this.getList()
    },
    getList () {
      this.$Loading.start()
      this.$axios.get('/car/list/'+this.brandParam.fid+'/'+this.showData.pageNum)
      .then(function (response) {
        if (response.data.success) {
          this.showData = response.data.data
          this.$Loading.finish()
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
    },
  }
}
</script>




// WEBPACK FOOTER //
// src/views/carbrand/list.vue